import * as React from 'react'
import { FollowUpModal, IgnoreTaskModal } from '../FollowUpModals'
import { useCoachDashboard } from '../CoachDashboardProvider'

export function TaskCell({ row }) {
  const url = row.original.service_request_url
  const task = row.original.coach_next_task

  if (task === 'Send Follow-Up Message')
    return <FollowUpTasks row={row} task={task} />
  if (url) return <a href={url}>{task}</a>
  return task
}

const FollowUpTasks = ({ row, task }) => {
  const { setUnfilteredDashboardData, current_user } = useCoachDashboard()
  const serviceRequestId = row.original.service_request_id
  const [followUpModalOpen, setFollowUpModalOpen] = React.useState(false)
  const [ignoreTaskModalOpen, setIgnoreTaskModalOpen] = React.useState(false)
  const handleFollowUpClick = () => {
    setFollowUpModalOpen(true)
  }

  const handleIgnoreClick = () => {
    setIgnoreTaskModalOpen(true)
  }

  const onSuccess = () => {
    setUnfilteredDashboardData((prevData) => {
      const newActionsRequired = [
        ...prevData.actionsRequired.filter(
          (action) => action.service_request_id !== serviceRequestId,
        ),
      ]
      return {
        ...prevData,
        actionsRequired: newActionsRequired,
      }
    })
    setFollowUpModalOpen(false)
  }
  return (
    <>
      <a
        className={'cursor-pointer'}
        onClick={handleFollowUpClick}
        title={'Send Follow-Up Message'}
      >
        {task}
      </a>{' '}
      |{' '}
      <a
        className={'cursor-pointer'}
        title={'Ignore follow-up task'}
        onClick={handleIgnoreClick}
      >
        Ignore
      </a>
      <FollowUpModal
        modalOpen={followUpModalOpen}
        setModalOpen={setFollowUpModalOpen}
        serviceRequest={row.original}
        onSuccess={onSuccess}
        candidateFirstName={row.original.candidate_first_name}
        coachFirstName={current_user.first_name}
      />{' '}
      <IgnoreTaskModal
        modalOpen={ignoreTaskModalOpen}
        setModalOpen={setIgnoreTaskModalOpen}
        serviceRequestId={serviceRequestId}
        url={row.original.service_request_url}
      />
    </>
  )
}
